module.exports = __webpack_public_path__ + "img/symbol_14.93c874b4.png";